module.exports = __webpack_public_path__ + "img/thumb-006-06.fe1a97c7.png";